<!-- <ngx-spinner type="ball-circus"></ngx-spinner> -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-circus" [fullScreen]="true"
	><p style="color: white"></p>
	<div class="animation-heartbeat animate-count-infinite animate-duration-5s display-10">Loading...</div>
</ngx-spinner>
<p-toast></p-toast>
<router-outlet></router-outlet>
<p-confirmDialog
	[autoZIndex]="true"
	[baseZIndex]="99999999"
	acceptButtonStyleClass="p-button-success"
	rejectButtonStyleClass="p-button-danger"
></p-confirmDialog>
